export default "__VITE_ASSET__Bw0xBu8A__"